import { IconProps, Notes } from 'grommet-icons';

export const AuditLogIcon: React.FC<IconProps> = (props) => <Notes size="24px" color="brand" {...props} />;
